
export default [
    {
        name: "QuotationCreate",
        path: "quotation",
        component: () => import('./../../views/Sales/QuotationCreateView')
    },
    {
        name: "QuotationDisplay",
        path: "quotation/:id",
        component: () => import('./../../views/Sales/QuotationDisplayView')
    },
    {
        name: "QuotationEdit",
        path: "quotation/:id/edit",
        component: () => import('./../../views/Sales/QuotationEditView')
    },
    {
        name: "Quotations",
        path: "quotations",
        component: () => import('./../../views/Sales/QuotationListView')
    }
]